const EditItem = ({ label: Label, children }: React.PropsWithChildren<{ label: React.ReactChild }>) => {
    return (<div className="mb-3">
        <label className="w-xl col-form-label font-weight-normal">{Label}</label>
        <div className="w-lg">{children}</div>
    </div>)
}

export default EditItem;